import { popupError, popupSuccess } from "@service/zendesk";

export const CopyToClipboard = (text: string) => {
  if (text === "") {
    popupError("Erro ao copiar conteúdo.", false);
    return;
  }

  navigator.clipboard
    .writeText(text)
    .then(() => {
      popupSuccess("Conteúdo copiado para a área de transferência.", false);
    })
    .catch(() => {
      popupError("Erro ao copiar conteúdo.", false);
    });
};
